module.exports = __webpack_public_path__ + "2e2cebc97ce5f8764c8c502b16e5d72d.MP3";